<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const { isLighthouseBot } = useLighthouse()

const JackpotSection = defineAsyncComponent(async () => await import('./jackpot-section.vue'))
const LiveStream = defineAsyncComponent(async () => await import('~/components/common/casino/live-stream.vue'))
const HotGames = defineAsyncComponent(async () => await import('./games-hot.vue'))
const Promotion = defineAsyncComponent(async () => await import('~/components/common/promotion.vue'))
const MainMenuTab = defineAsyncComponent(async () => await import('~/components/desktop/pages/home/main-menu-tab.vue'))
const GameCategory = defineAsyncComponent(async () => await import('~/components/desktop/pages/home/game-category.vue'))
</script>
<template>
  <div class="home-page">
    <MainMenuTab />
    <div class="container">
      <GameCategory />
      <template v-if="!isLighthouseBot">
        <LiveStream />
        <JackpotSection />
        <HotGames />
        <Promotion />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/home/index.scss';
</style>
